import { useEffect } from 'react';

import useImxImrSeasonData from '../../../state/imxImrSeason/UseImxImrSeasonData';

const useImxImrSeasonDropdown = () => {
  const { imxImrSeasonState, getImxImrSeasons } = useImxImrSeasonData();

  useEffect(() => {
    if (imxImrSeasonState?.isArrayLoading !== true && imxImrSeasonState?.isArrayLoaded !== true) {
      getImxImrSeasons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imxImrSeasonState]);
  return {
    imxImrSeasonState
  };
};

export default useImxImrSeasonDropdown;